<template>

<div class="content-box">
    <div class="login-box">
      <div class="left-box">
        <div class="left-box-txt-zh">欢迎参赛</div>
        <div class="left-box-txt-en">Welcome to the</div>
        <div class="left-box-txt-en">CHINA BRAND DESIGN AWARDS!</div>
        <div class="left-box-txt-account">已有账号？</div>
        <div class="btn-go-login" @click="goLogin()">马上登录</div>
      </div>
      <div class="right-box">
        <div class="success-box">
          <span class="success-zh">注册成功！</span>
          <span class="success-en">S u c c e s s !</span>
          <img src="~@/assets/icon_reg_success.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "register_success",
  components:{
  },
  data() {
    return {
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    goLogin(){
      this.$router.push({name:'Index'})
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";

.content-box {
  width: 1440px;
  height: 925px;
  overflow: hidden;
  background: url(~@/assets/login_background.png);
  background-size: cover;
  .login-box {
    width: 936px;
    height: 537px;
    margin-top: 150px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .left-box{
      width: 400px;
      height: 100%;
      float: left;
      background: #FF3B30;
      .left-box-txt-zh{
        font-size: 24px;
        color: #FFFFFF;
        font-weight: 350;
        margin-left: 55px;
        margin-top: 130px;
      }
      .left-box-txt-en{
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 350;
        font-style: italic;
        margin-left: 55px;
      }
      .left-box-txt-account{
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 15px;
      }
      .btn-go-login{
        width: 190px;
        height: 33px;
        cursor: pointer;
        margin-left: auto;
        margin-right: auto;
        margin-top: 25px;
        line-height: 33px;
        border-radius: 3px;
        text-align: center;
        font-size: 12px;
        color: #FF3B30;
        background: #FFFFFF;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }
    }
    .right-box{
      width: 536px;
      height: 100%;
      float: left;
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      .success-box{
        width: 120px;
        height: 120px;
        span{
          color: #FF3B30;
          width: 100%;
          float: left;
          clear: left;
        }
        img{
          width: 50px;
          height: 50px;
          margin-left: 35px;
          margin-top: 20px;
        }
        .success-zh{
          width: 100%;
          font-size: 24px;
          font-weight: 500;
          display: block;
          text-align: center;
        }
        .success-en{
          width: 100%;
          font-size: 16px;
          font-weight: 500;
          font-style: italic;
        }
      }
    }
  }
}
</style>
